import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { App as CapacitorApp } from '@capacitor/app';

const HOME_PATH = '/';
const MOBILE_WELCOME_PATH = '/mobile-welcome';

const ROUTES_THAT_RETURN_HOME = [
  '/campaign/',
  '/contribute',
  '/profile',
  '/terms',
  '/privacy',
  '/about',
  '/advertise',
  '/reset-password',
  '/update-password',
];

export default function AndroidBackButtonHandler() {
  const navigate = useNavigate();
  const location = useLocation();
  const locationRef = useRef(location);

  useEffect(() => {
    locationRef.current = location;
  }, [location]);

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    const listenerPromise = CapacitorApp.addListener('backButton', () => {
      const backEvent = new CustomEvent('ballotr:androidBack', {
        cancelable: true,
      });

      const wasNotCanceled = window.dispatchEvent(backEvent);

      if (!wasNotCanceled) {
        return;
      }

      const currentPath =
        locationRef.current?.pathname || window.location.pathname || HOME_PATH;

      if (currentPath === HOME_PATH || currentPath === MOBILE_WELCOME_PATH) {
        CapacitorApp.minimizeApp();
        return;
      }

      if (currentPath === '/auth') {
        navigate(MOBILE_WELCOME_PATH, { replace: true });
        return;
      }

      const shouldReturnHome = ROUTES_THAT_RETURN_HOME.some((route) =>
        currentPath.startsWith(route)
      );

      if (shouldReturnHome) {
        navigate(HOME_PATH, { replace: true });
        return;
      }

      navigate(HOME_PATH, { replace: true });
    });

    return () => {
      listenerPromise.then((listener) => listener.remove());
    };
  }, [navigate]);

  return null;
}